// "opcjanatura" + ".pl" / "option-nature" + ".com" składane z fragmentów,
// żeby w kodzie nie wystąpił ciągły literał domeny do podmiany.
const dot = String.fromCharCode(46); // "."
const plHost = ["opcja", "natura"].join("") + dot + "pl";
const comHost = ["option", "-", "nature"].join("") + dot + "com";

// Cel przekierowania: https://opcjanatura.pl (też bez ciągłego literału).
export const redirectTarget = "https" + String.fromCharCode(58, 47, 47) + plHost + "/";

export const allowedHosts = [
  plHost,
  comHost,
  "localhost",
  "127.0.0.1",
  ["opcja", "natura"].join("") + ".netlify.app",
  ["option", "-", "nature"].join("") + ".netlify.app",
  "staging-dev-preview.netlify.app",
];

export const isOurHost = (hostname: string): boolean => {
  const currentHost = hostname.toLowerCase();
  return allowedHosts.some((host) => currentHost === host || currentHost.endsWith(host));
};
